// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RawTokenAmount } from './RawTokenAmount';
import {
    RawTokenAmountFromJSON,
    RawTokenAmountFromJSONTyped,
    RawTokenAmountToJSON,
} from './RawTokenAmount';

/**
 * 
 * @export
 * @interface TokenBalanceChange
 */
export interface TokenBalanceChange {
    /**
     * 
     * @type {string}
     * @memberof TokenBalanceChange
     */
    userAccount: string;
    /**
     * 
     * @type {string}
     * @memberof TokenBalanceChange
     */
    tokenAccount: string;
    /**
     * 
     * @type {RawTokenAmount}
     * @memberof TokenBalanceChange
     */
    rawTokenAmount: RawTokenAmount;
    /**
     * 
     * @type {string}
     * @memberof TokenBalanceChange
     */
    mint: string;
}

/**
 * Check if a given object implements the TokenBalanceChange interface.
 */
export function instanceOfTokenBalanceChange(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userAccount" in value;
    isInstance = isInstance && "tokenAccount" in value;
    isInstance = isInstance && "rawTokenAmount" in value;
    isInstance = isInstance && "mint" in value;

    return isInstance;
}

export function TokenBalanceChangeFromJSON(json: any): TokenBalanceChange {
    return TokenBalanceChangeFromJSONTyped(json, false);
}

export function TokenBalanceChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenBalanceChange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userAccount': json['userAccount'],
        'tokenAccount': json['tokenAccount'],
        'rawTokenAmount': RawTokenAmountFromJSON(json['rawTokenAmount']),
        'mint': json['mint'],
    };
}

export function TokenBalanceChangeToJSON(value?: TokenBalanceChange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userAccount': value.userAccount,
        'tokenAccount': value.tokenAccount,
        'rawTokenAmount': RawTokenAmountToJSON(value.rawTokenAmount),
        'mint': value.mint,
    };
}

